export enum SignalrProgressState {
  None = 0,
  InProgress = 1,
  Error = 2,
  Done = 3
}
